// eslint-disable-next-line import/prefer-default-export
export const ConversationStartIcon = () => (
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12.75V1.5C0 1.0875 0.146875 0.734375 0.440625 0.440625C0.734375 0.146875 1.0875 0 1.5 0H10.5C10.9125 0 11.2656 0.146875 11.5594 0.440625C11.8531 0.734375 12 1.0875 12 1.5V5.30625C11.875 5.28125 11.75 5.26562 11.625 5.25938C11.5 5.25313 11.375 5.25 11.25 5.25C11.125 5.25 11 5.25313 10.875 5.25938C10.75 5.26562 10.625 5.28125 10.5 5.30625V1.5H1.5V9H6.80625C6.78125 9.125 6.76563 9.25 6.75938 9.375C6.75313 9.5 6.75 9.625 6.75 9.75C6.75 9.875 6.75313 10 6.75938 10.125C6.76563 10.25 6.78125 10.375 6.80625 10.5H2.25L0 12.75ZM3 4.5H9V3H3V4.5ZM3 7.5H6.75V6H3V7.5ZM10.5 12.75V10.5H8.25V9H10.5V6.75H12V9H14.25V10.5H12V12.75H10.5Z"
      fill="currentColor"
    />
  </svg>
);
